if (!customElements.get('quiz-drawer')) {
  class QuizDrawer extends DrawerComponent {
    constructor() {
      super();
      this.currentStep = 1;
      this.totalSteps = 4;
      this.answers = {};

      this.productDatabase = {
        face: {
          dryness: {
            products: [
              {
                name: 'Cleansing Milk',
                handle: 'cleansing-milk',
                price: '199 kr',
                reason: 'Milt rengörande, skyddande och bevarar hudens fuktbalans.',
                image: null,
              },
              {
                name: 'Blackcurrant Oil',
                handle: 'blackcurrant-oil',
                price: '349 kr',
                reason: 'Oparfymerad oljelotion som stärker, skyddar och återfuktar.',
                image: null,
              },
              {
                name: 'Quick Repair Cream',
                handle: 'quick-repair-cream',
                price: '349 kr',
                reason: 'Oparfymerad näringsrik fuktkräm.',
                image: null,
              },
              {
                name: 'Q Omega Supreme',
                handle: 'q-omega-supreme',
                price: '472 kr',
                reason: 'Näringsstöd som återfuktar och stärker hudbarriären.',
                image: null,
              },
              {
                name: 'Blackcurrant Lip Balm',
                handle: 'blackcurrant-lip-balm',
                price: '65 kr',
                reason: 'Skyddar läppar och torra hudpartier.',
                image: null,
              },
            ],
          },
          aging: {
            products: [
              {
                name: 'Cleansing Milk',
                handle: 'cleansing-milk',
                price: '199 kr',
                reason: 'Mild rengöring som bevarar hudens fukt.',
                image: null,
              },
              {
                name: 'Q Balancing Booster',
                handle: 'q-balancing-booster',
                price: '199 kr',
                reason: 'Förbereder huden och stärker hudbarriären.',
                image: null,
              },
              {
                name: 'Intensive Nourishing Serum',
                handle: 'intensive-nourishing-serum',
                price: '399 kr',
                reason: 'Koncentrerat serum för fastare och slätare hud.',
                image: null,
              },
              {
                name: 'Intensive Nourishing Cream',
                handle: 'intensive-nourishing-cream',
                price: '399 kr',
                reason: 'Djupverkande kräm som låser in fukten och stärker huden.',
                image: null,
              },
              {
                name: 'Q Omega Supreme',
                handle: 'q-omega-supreme',
                price: '472 kr',
                reason: 'Stärker huden inifrån med essentiella fettsyror.',
                image: null,
              },
            ],
          },
          pigmentation: {
            products: [
              {
                name: 'Cleansing Milk',
                handle: 'cleansing-milk',
                price: '199 kr',
                reason: 'Varsam rengöring som förbereder huden.',
                image: null,
              },
              {
                name: 'Q Balancing Booster',
                handle: 'q-balancing-booster',
                price: '199 kr',
                reason: 'Jämnar ut och balanserar hudtonen.',
                image: null,
              },
              {
                name: 'Intensive Nourishing Serum',
                handle: 'intensive-nourishing-serum',
                price: '399 kr',
                reason: 'Hjälper huden att återhämta sig och bli jämnare.',
                image: null,
              },
              {
                name: 'Lingonberry Hi-tech Serum in Cream',
                handle: 'lingonberry-hi-tech-serum-in-cream',
                price: '649 kr',
                reason: 'Ljusnar upp och jämnar ut hudtonen.',
                image: null,
              },
              {
                name: 'Q Omega Supreme',
                handle: 'q-omega-supreme',
                price: '472 kr',
                reason: 'Stödjer hudens naturliga läkningsprocess inifrån.',
                image: null,
              },
            ],
          },
          stress: {
            products: [
              {
                name: 'Cleansing Milk',
                handle: 'cleansing-milk',
                price: '199 kr',
                reason: 'Skonsam rengöring som inte irriterar.',
                image: null,
              },
              {
                name: 'Quick Repair Cream',
                handle: 'quick-repair-cream',
                price: '349 kr',
                reason: 'Lugnande kräm som reparerar stressad hud.',
                image: null,
              },
              {
                name: 'Q Omega Supreme',
                handle: 'q-omega-supreme',
                price: '472 kr',
                reason: 'Stärker hudbarriären inifrån.',
                image: null,
              },
              {
                name: 'Blackcurrant Lip Balm',
                handle: 'blackcurrant-lip-balm',
                price: '65 kr',
                reason: 'Skyddar torra och spruckna läppar.',
                image: null,
              },
            ],
          },
          unbalanced: {
            products: [
              {
                name: 'Q Ultra Care',
                handle: 'q-ultra-care',
                price: '149 kr',
                reason: 'Skonsam tvätt som balanserar huden.',
                image: null,
              },
              {
                name: 'Q Balancing Booster',
                handle: 'q-balancing-booster',
                price: '199 kr',
                reason: 'Återställer hudens naturliga balans.',
                image: null,
              },
              {
                name: 'Quick Repair Cream',
                handle: 'quick-repair-cream',
                price: '349 kr',
                reason: 'Reparerande kräm som stärker hudbarriären.',
                image: null,
              },
              {
                name: 'Q Omega Supreme',
                handle: 'q-omega-supreme',
                price: '472 kr',
                reason: 'Balanserar hudens fettproduktion inifrån.',
                image: null,
              },
            ],
          },
        },
        hair: {
          scalp: {
            products: [
              {
                name: 'Intensive Nourishing Serum',
                handle: 'intensive-nourishing-serum',
                price: '399 kr',
                reason: 'Kan användas som intensiv hårbottenbehandling.',
                image: null,
              },
              {
                name: 'Quick Relief Shampoo',
                handle: 'quick-relief-shampoo',
                price: '279 kr',
                reason: 'Snabb lindring vid klåda och fjällning.',
                image: null,
              },
              {
                name: 'Q Conditioner',
                handle: 'q-conditioner',
                price: '189 kr',
                reason: 'Balsam som lugnar och återfuktar hårbotten.',
                image: null,
              },
              {
                name: 'Q Omega Supreme',
                handle: 'q-omega-supreme',
                price: '472 kr',
                reason: 'Stödjer hårbottens hälsa inifrån.',
                image: null,
              },
            ],
          },
        },
        intimate: {
          intimate_dryness: {
            products: [
              {
                name: 'Q Ultra Care',
                handle: 'q-ultra-care',
                price: '149 kr',
                reason: 'Skonsam intimtvätt som bevarar naturlig balans.',
                image: null,
              },
              {
                name: 'Blackcurrant Oil',
                handle: 'blackcurrant-oil',
                price: '349 kr',
                reason: 'Milt vårdande olja speciellt för intimområdet.',
                image: null,
              },
              {
                name: 'Q Omega Supreme',
                handle: 'q-omega-supreme',
                price: '472 kr',
                reason: 'Stödjer slemhinnornas hälsa inifrån.',
                image: null,
              },
            ],
          },
        },
        body: {
          body_sensitive: {
            products: [
              {
                name: 'Q Ultra Care',
                handle: 'q-ultra-care',
                price: '149 kr',
                reason: 'Oparfymerad tvätt för känslig hud.',
                image: null,
              },
              {
                name: 'Blackcurrant Oil',
                handle: 'blackcurrant-oil',
                price: '349 kr',
                reason: 'Lugnande olja som stärker hudbarriären.',
                image: null,
              },
              {
                name: 'Quick Repair Cream',
                handle: 'quick-repair-cream',
                price: '349 kr',
                reason: 'Reparerande kräm för känslig och reaktiv hud.',
                image: null,
              },
              {
                name: 'Q Omega Supreme',
                handle: 'q-omega-supreme',
                price: '472 kr',
                reason: 'Stärker hudbarriären inifrån.',
                image: null,
              },
              {
                name: 'Blackcurrant Lip Balm',
                handle: 'blackcurrant-lip-balm',
                price: '65 kr',
                reason: 'Skyddar torra läppar, händer och fötter.',
                image: null,
              },
            ],
          },
        },
      };
    }

    connectedCallback() {
      super.connectedCallback();

      // Texter på besökarens språk (sections.quiz.* i språkfilerna), renderade av quiz-drawer.liquid
      const i18nEl = this.querySelector('[data-quiz-i18n]');
      try {
        this.i18n = i18nEl ? JSON.parse(i18nEl.textContent) : {};
      } catch (e) {
        this.i18n = {};
      }
      // Varje rekommendation får en nyckel (område_besvär_index) som motiveringen slås upp med
      Object.entries(this.productDatabase).forEach(([area, concerns]) => {
        Object.entries(concerns).forEach(([concern, data]) => {
          data.products.forEach((product, index) => {
            product.reasonKey = `${area}_${concern}_${index}`;
          });
        });
      });
      // Språk-/marknadsprefix, t.ex. /en-eu, så att länkar och priser följer besökarens marknad
      const rootUrl = (window.FoxTheme && window.FoxTheme.routes && window.FoxTheme.routes.root_url) || '/';
      this.rootUrl = rootUrl.replace(/\/$/, '');

      this.progressBar = this.querySelector('[data-progress-bar]');
      this.stepIndicator = this.querySelector('[data-step-indicator]');
      this.backBtn = this.querySelector('[data-quiz-back]');
      this.quizBody = this.querySelector('[data-quiz-body]');
      this.resultsHeading = this.querySelector('[data-results-heading]');
      this.resultsSubtext = this.querySelector('[data-results-subtext]');
      this.resultsProducts = this.querySelector('[data-results-products]');

      this.backBtn.addEventListener('click', () => this.goBack());

      const restartBtn = this.querySelector('[data-quiz-restart]');
      if (restartBtn) {
        restartBtn.addEventListener('click', () => this.restart());
      }

      this.querySelectorAll('[data-quiz-options]').forEach((container) => {
        container.addEventListener('click', (e) => {
          const option = e.target.closest('.quiz-option');
          if (!option) return;
          this.selectOption(option, container);
        });
      });
    }

    selectOption(option, container) {
      container.querySelectorAll('.quiz-option').forEach((opt) => opt.classList.remove('selected'));
      option.classList.add('selected');

      const value = option.dataset.value;
      this.answers[`step${this.currentStep}`] = value;

      /* After selecting area in step 1, filter step 2 options */
      if (this.currentStep === 1) {
        this.filterStep2Options(value);
      }

      setTimeout(() => {
        if (this.currentStep < this.totalSteps) {
          this.goToStep(this.currentStep + 1);
        } else {
          this.showResults();
        }
      }, 300);
    }

    filterStep2Options(area) {
      const step2 = this.querySelector('[data-quiz-step="2"]');
      if (!step2) return;

      step2.querySelectorAll('.quiz-option[data-areas]').forEach((option) => {
        const areas = option.dataset.areas.split(',').map((a) => a.trim());
        if (areas.includes(area)) {
          option.style.display = '';
        } else {
          option.style.display = 'none';
          option.classList.remove('selected');
        }
      });
    }

    goToStep(step) {
      const currentEl = this.querySelector(`[data-quiz-step="${this.currentStep}"]`);
      const nextEl = this.querySelector(`[data-quiz-step="${step}"]`);

      if (!currentEl || !nextEl) return;

      currentEl.classList.add('quiz-step--exiting');

      setTimeout(() => {
        currentEl.hidden = true;
        currentEl.classList.remove('quiz-step--exiting');

        nextEl.hidden = false;
        nextEl.classList.add('quiz-step--entering');

        setTimeout(() => {
          nextEl.classList.remove('quiz-step--entering');
        }, 350);

        this.currentStep = step;
        this.updateUI();
        this.quizBody.scrollTop = 0;
      }, 250);
    }

    goBack() {
      if (this.currentStep <= 1) return;

      /* Handle going back from results */
      if (this.currentStep === 'results') {
        const currentEl = this.querySelector('[data-quiz-step="results"]');
        const prevEl = this.querySelector(`[data-quiz-step="${this.totalSteps}"]`);

        if (!currentEl || !prevEl) return;

        currentEl.hidden = true;
        prevEl.hidden = false;
        prevEl.classList.add('quiz-step--entering');

        setTimeout(() => {
          prevEl.classList.remove('quiz-step--entering');
        }, 350);

        this.currentStep = this.totalSteps;
        this.updateUI();
        this.quizBody.scrollTop = 0;
        return;
      }

      const currentEl = this.querySelector(`[data-quiz-step="${this.currentStep}"]`);
      const prevStep = this.currentStep - 1;
      const prevEl = this.querySelector(`[data-quiz-step="${prevStep}"]`);

      if (!currentEl || !prevEl) return;

      currentEl.hidden = true;
      prevEl.hidden = false;
      prevEl.classList.add('quiz-step--entering');

      setTimeout(() => {
        prevEl.classList.remove('quiz-step--entering');
      }, 350);

      this.currentStep = prevStep;
      this.updateUI();
      this.quizBody.scrollTop = 0;
    }

    updateUI() {
      const progress =
        this.currentStep === 'results' ? 100 : (this.currentStep / this.totalSteps) * 100;
      this.progressBar.style.width = `${progress}%`;

      if (this.currentStep === 'results') {
        this.stepIndicator.textContent = this.i18n.results || 'Resultat';
        this.backBtn.style.visibility = 'hidden';
      } else {
        const stepTemplate = this.i18n.step_of || 'Steg [step] av [total]';
        this.stepIndicator.textContent = stepTemplate
          .replace('[step]', this.currentStep)
          .replace('[total]', this.totalSteps);
        this.backBtn.style.visibility = this.currentStep > 1 ? 'visible' : 'hidden';
      }
    }

    showResults() {
      const currentEl = this.querySelector(`[data-quiz-step="${this.currentStep}"]`);
      const resultsEl = this.querySelector('[data-quiz-step="results"]');

      currentEl.classList.add('quiz-step--exiting');

      setTimeout(() => {
        currentEl.hidden = true;
        currentEl.classList.remove('quiz-step--exiting');

        resultsEl.hidden = false;
        resultsEl.classList.add('quiz-step--entering');

        setTimeout(() => {
          resultsEl.classList.remove('quiz-step--entering');
        }, 350);

        this.currentStep = 'results';
        this.updateUI();
        this.renderProducts();
        this.quizBody.scrollTop = 0;
      }, 250);
    }

    getRecommendations() {
      const area = this.answers.step1 || 'face';
      const concern = this.answers.step2 || 'dryness';

      const areaData = this.productDatabase[area];
      if (!areaData) {
        return this.productDatabase.face.dryness.products;
      }

      const concernData = areaData[concern];
      if (!concernData) {
        const firstConcern = Object.values(areaData)[0];
        return firstConcern ? firstConcern.products : this.productDatabase.face.dryness.products;
      }

      return concernData.products;
    }

    renderProducts() {
      const products = this.getRecommendations();
      this.resultsProducts.innerHTML = '';

      products.forEach((product) => {
        const card = document.createElement('a');
        card.href = `${this.rootUrl}/products/${product.handle}`;
        card.dataset.handle = product.handle;
        const reason = (this.i18n.reasons && this.i18n.reasons[product.reasonKey]) || product.reason;
        card.className = 'quiz-product-card';
        card.innerHTML = `
          <div class="quiz-product-card__image" style="display:flex;align-items:center;justify-content:center;font-size:2.4rem;color:rgba(var(--color-foreground),0.15);">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="4" y="8" width="24" height="20" rx="2" stroke="currentColor" stroke-width="1.5"/>
              <path d="M4 22L12 16L18 20L24 15L28 18" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <circle cx="21" cy="14" r="2" stroke="currentColor" stroke-width="1.5"/>
            </svg>
          </div>
          <div class="quiz-product-card__info">
            <p class="quiz-product-card__name">${product.name}</p>
            <p class="quiz-product-card__reason">${reason}</p>
            <span class="quiz-product-card__price" data-quiz-price></span>
          </div>
          <span class="quiz-product-card__add" aria-label="${this.i18n.view_product || 'Visa produkt'}">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6 3L11 8L6 13" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </span>
        `;
        this.resultsProducts.appendChild(card);
      });

      this.fetchProductImages(products);
    }

    async fetchProductImages(products) {
      for (const product of products) {
        try {
          const resp = await fetch(`${this.rootUrl}/products/${product.handle}.js`);
          if (!resp.ok) {
            this.showFallbackPrice(product);
            continue;
          }
          const data = await resp.json();
          // Priset i besökarens valuta (produktens JSON följer marknaden i rootUrl)
          const priceEl = this.resultsProducts.querySelector(
            `a[data-handle="${product.handle}"] [data-quiz-price]`
          );
          if (priceEl && typeof data.price === 'number' && window.Shopify && typeof Shopify.formatMoney === 'function') {
            const moneyFormat = window.FoxTheme && window.FoxTheme.settings && window.FoxTheme.settings.moneyFormat;
            priceEl.innerHTML = Shopify.formatMoney(data.price, moneyFormat);
          } else {
            this.showFallbackPrice(product);
          }
          if (data.featured_image) {
            const imgEl = this.resultsProducts.querySelector(
              `a[data-handle="${product.handle}"] .quiz-product-card__image`
            );
            if (imgEl) {
              const img = document.createElement('img');
              img.src = data.featured_image;
              img.alt = product.name;
              img.className = 'quiz-product-card__image';
              img.loading = 'lazy';
              imgEl.replaceWith(img);
            }
          }
        } catch (e) {
          this.showFallbackPrice(product);
        }
      }
    }

    // Det hårdkodade priset gäller bara i kronor – visas inte i andra valutor
    showFallbackPrice(product) {
      const currency = window.Shopify && window.Shopify.currency && window.Shopify.currency.active;
      if (currency && currency !== 'SEK') return;
      const priceEl = this.resultsProducts.querySelector(`a[data-handle="${product.handle}"] [data-quiz-price]`);
      if (priceEl && !priceEl.textContent) priceEl.textContent = product.price;
    }

    restart() {
      this.answers = {};
      this.currentStep = 1;

      this.querySelectorAll('.quiz-step').forEach((step) => {
        step.hidden = step.dataset.quizStep !== '1';
        step.classList.remove('quiz-step--entering', 'quiz-step--exiting');
      });

      this.querySelectorAll('.quiz-option').forEach((opt) => {
        opt.classList.remove('selected');
        opt.style.display = '';
      });

      this.resultsProducts.innerHTML = '';
      this.updateUI();
      this.quizBody.scrollTop = 0;
    }

    prepareToShow() {
      super.prepareToShow();
      this.restart();
    }
  }

  customElements.define('quiz-drawer', QuizDrawer);
}
